import { BaseLoginError } from "./BaseLoginError";

export class UserNotFound extends BaseLoginError {

    constructor(isShow : boolean) {
        super (isShow);
    }

}